/**
 * URL API du super-admin.
 *
 * Create React App injecte REACT_APP_* au moment du `npm run build` uniquement.
 * Sans `.env.production`, le build peut appeler localhost ou le domaine du super-admin
 * → 404 Apache « The requested URL was not found on this server ».
 */
const DEFAULT_LOCAL_API = 'http://localhost:8000/api';
const DEFAULT_PRODUCTION_API = 'https://api26.sherlook.fr/api';

function isLocalBrowserHost(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

function resolveApiUrl(): string {
  const fromBuild = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');

  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (!isLocalBrowserHost(host)) {
      if (!fromBuild || fromBuild.includes('localhost') || fromBuild.includes('127.0.0.1')) {
        return DEFAULT_PRODUCTION_API;
      }
      const withoutApi = fromBuild.replace(/\/api\/?$/, '');
      if (withoutApi === host || (fromBuild.includes(host) && !fromBuild.includes('api26'))) {
        return DEFAULT_PRODUCTION_API;
      }
      return fromBuild.endsWith('/api') ? fromBuild : `${fromBuild}/api`;
    }
  }

  return fromBuild || DEFAULT_LOCAL_API;
}

export const config = {
  apiUrl: resolveApiUrl(),
  appName: 'Sherlook Super Admin',
  version: '1.0.0',
};

/** Origine API sans `/api` (fichiers statiques sous `/uploads/...`) */
export function getApiOrigin(): string {
  const raw = config.apiUrl.replace(/\/api\/?$/, '');
  return raw || DEFAULT_PRODUCTION_API.replace(/\/api\/?$/, '');
}
